/** @jsx jsx */
import { jsx } from "theme-ui"
import Select from "react-select"

const CountyFilter = ({ className, options, value, onChange, id }) => {
  const opts = options.map(label => ({ value: label, label }))
  const selected = value.map(v => ({ value: v, label: v }))

  const handleChange = data => {
    if (!data || data.length === 0) {
      onChange([])
      return
    }
    onChange(data.map(d => d.value))
  }

  return (
    <Select
      inputId={id}
      className={className}
      options={opts}
      value={selected}
      isSearchable={true}
      isMulti
      onChange={handleChange}
      placeholder="All"
    />
  )
}

export default CountyFilter
